// import BootstrapModal from '@/components/modal/bootstra-modal/BootstrapModal';
import { tradeApi } from '@/api/exchange.page';
import { mapGetters, mapActions } from 'vuex';
import { socketName } from '@/common/constants/globalConfig';
import { getterTypes } from '@/store/getter-types';
import { actionTypes } from '@/store/action-types';
import { selectOption } from '@/common/constants/selectOption';
import tool from '@/common/js/tool';
// import CommonTable from '@/components/table/CommonTable';
import tradeMixin from '@/common/mixin/tradeMixin';
import { Howl } from 'howler';
import OpenOrderTable from './components/OpenOrderTable';
import HistoryOrderTable from './components/HistoryOrderTable';
import ConfirmModal from '@/components/ConfirmModal/ConfirmModal';
import MessageModal from '@/components/MessageModal';

//state comments
// ------------------------
// Allow Api Calls
// READY - allow to call api

// Prevent Api Calls
// CONFIRMINGCANCEL - when user is confirming to cancel order
// LOADING - when api is called and waiting for response

const READY = 1;
const CONFIRMINGCANCEL = 2;
const LOADING = 4;

export default {
  name: 'MyTrade',
  data() {
    return {
      selectedTab: 0,
      pagination: {
        rowsPerPage: -1
      },
      tabs: [
        { id: 1, label: this.$t('labels.openOrders') },
        { id: 2, label: this.$t('labels.orderHistory') }
      ],
      showCancelOrderModal: false,
      // 当前委托数据
      currentEntrust: {
        //new data
        state: READY,
        hasMessage: false, // everytime websocket receives message true, else false

        //old data
        list: [],
        data: {},
        loading: false,
        // 查询相关数据
        query: {
          current: 10,
          size: 10
        },
        // 防止短时间内重复发请求
        cancelEntrust: false,
        subscribeChannel: 'order.pending.update'
      },
      // 历史委托数据
      historyEntrust: {
        //new data
        state: READY,
        hasMessage: false, // everytime websocket receives message true, else false

        list: [],
        data: {},
        loading: false,
        // 查询相关数据
        query: {
          current: 1,
          size: 10
        },
        // 防止短时间内重复发请求
        cancelHistory: false,
        subscribeChannel: 'order.finished.update'
      },
      // 交易类型
      // transTypeMap: {
      //   '1': '买入',
      //   '2': '卖出',
      // },
      // // 交易状态
      // transStatusMap: {
      //   '0': '待成交',
      //   '1': '已成交',
      //   '2': '已取消',
      // },
      // 控制批量撤销modal显示与隐藏
      cancelAllModalShow: false,
      cancelAllCommitting: false,
      // 控制撤销单个订单提示modal显示与隐藏
      cancelOrderModalShow: false,
      cancelOrderCommitting: false,

      matchOrderModalShow: false,
      cancelOrderId: '',
      cancelOrderPair: '',
      matchCount: 0,
      propExpand: {
        expand: false,
        row: {}
      }
    };
  },
  mixins: [tradeMixin],
  methods: {
    onCancelOrderModalHide() {
      this.currentEntrust.state = READY;
      if (this.currentEntrust.hasMessage) {
        this.getCurrentEntrust();
      }
    },
    onMatchOrderModalHide() {
      this.matchCount = 0;
      this.matchOrderModalShow = false;
    },
    ...mapActions([actionTypes.GET_MARKETLIST_ACTION, 'getMarketPair_action']),
    // 获取当前委托数据
    getCurrentEntrust() {
      if (READY == this.currentEntrust.state) {
        this.currentEntrust.state = LOADING;
        this.currentEntrust.hasMessage = false;

        let currentEntrust = this.currentEntrust;
        let query = currentEntrust.query;
        if (this.Getter_Token && !currentEntrust.cancelEntrust) {
          currentEntrust.cancelEntrust = true;
          currentEntrust.loading = true;
          tradeApi
            .serverGetEntrustOrderList({
              ...query,
              pair: this.Getter_Current_Market.symbol
              // symbol: this.Getter_Current_Market.symbol,
              // token: this.Getter_Token,
            })
            .then(res => {
              let data = res.data;
              currentEntrust.cancelEntrust = false;
              currentEntrust.loading = false;
              currentEntrust.data = data;

              //set timeout
              this.currentEntrust = currentEntrust;
              setTimeout(() => {
                if (this.currentEntrust.state == CONFIRMINGCANCEL) {
                  return;
                }

                this.currentEntrust.state = READY;

                //call api again if any message from web socket
                if (this.currentEntrust.hasMessage) {
                  return this.getCurrentEntrust();
                }
              }, 2000);
            })
            .catch(() => {
              currentEntrust.cancelEntrust = false;
              currentEntrust.loading = false;

              //swap back to READY state immediately
              this.currentEntrust.state = READY;
            });
        }
      }
    },
    // 获取历史委托数据
    getHistoryEntrust() {
      if (READY == this.historyEntrust.state) {
        this.historyEntrust.state = LOADING;
        this.historyEntrust.hasMessage = false;

        let historyEntrust = this.historyEntrust;
        let query = historyEntrust.query;
        if (this.Getter_Token && !historyEntrust.cancelHistory) {
          historyEntrust.cancelHistory = true;
          historyEntrust.loading = true;
          tradeApi
            .serverGetTurnoverOrderList({
              ...query
              // symbol: this.Getter_Current_Market.symbol,
              // token: this.Getter_Token,
            })
            .then(res => {
              let data = res.data;
              historyEntrust.cancelHistory = false;
              historyEntrust.loading = false;
              historyEntrust.data = data;

              //set timeout
              this.historyEntrust = historyEntrust;
              setTimeout(() => {
                if (this.historyEntrust.state == CONFIRMINGCANCEL) {
                  return;
                }

                this.historyEntrust.state = READY;

                //call api again if any message from web socket
                if (this.historyEntrust.hasMessage) {
                  return this.getHistoryEntrust();
                }
              }, 2000);
            })
            .catch(() => {
              historyEntrust.cancelHistory = false;
              historyEntrust.loading = false;

              //swap back to READY state immediately
              this.historyEntrust.state = READY;
            });
        }
      }
    },
    // 订阅当前委托数据
    // subscribeCurrentEntrust() {
    //   let channel = this.currentEntrust.subscribeChannel;
    //   this.$socket2.get(socketName.exchange).subscribe(
    //     channel,
    //     () => {
    //       this.getCurrentEntrust();
    //       /* 当交易被撮合和后需要再获取一次当前账户信息，这样才能保证账户信息实时更新，
    //     这里不在当前组件更新账户信息，而是让父组件去更新，因为账户数据在父组件
    //     */
    //       this.$emit('entrustUpdate');
    //     },
    //     {
    //       sub: channel,
    //     }
    //   );
    /* this.$socket.subscribe('orderList', (data) => {
      this.getCurrentEntrust();
    }); */
    // },
    // // 取消订阅当前委托数据
    // unSubscribeCurrentEntrust() {
    //   let channel = this.currentEntrust.subscribeChannel;
    //   this.$socket2.get(socketName.exchange).unSubscribe(channel, { cancel: channel });
    // },
    // 订阅历史委托数据
    // subscribeHistoryEntrust() {
    //   let channel = this.historyEntrust.subscribeChannel;
    //   this.$socket2.get(socketName.exchange).subscribe(
    //     channel,
    //     () => {
    //       this.getHistoryEntrust();
    //       /* 当交易被撮合和后需要再获取一次当前账户信息，这样才能保证账户信息实时更新，
    //     这里不在当前组件更新账户信息，而是让父组件去更新，因为账户数据在父组件
    //     */
    //       this.$emit('entrustUpdate');
    //     },
    //     {
    //       sub: channel,
    //     }
    //   );
    // },
    // // 取消订阅历史委托数据
    // unSubscribeHistoryEntrust() {
    //   let channel = this.historyEntrust.subscribeChannel;
    //   this.$socket2.get(socketName.exchange).unSubscribe(channel, { cancel: channel });
    // },
    // 确认撤销订单按钮点击事件
    cancelOrderBtnClick() {
      if (this.cancelOrderCommitting) {
        return;
      }
      this.cancelOrderCommitting = true;
      const data = {
        orderId: this.cancelOrderId,
        pair: this.cancelOrderPair,
        volume: '0' // Cancel all
      };
      this._requestCancelOrder(data);
    },
    // 确认批量撤销按钮点击事件
    cancelAllBtnClick() {
      if (this.cancelAllCommitting) {
        return;
      }
      this.cancelAllCommitting = true;
      this._requestCancelAllOrder(this.Getter_Current_Market.symbol);
    },
    // 提交撤销订单数据
    _requestCancelOrder(data) {
      tradeApi
        .serverCancelOrder(data)
        .then(() => {
          this.successNotify(this.$t('trade.cancel.success'));

          this.cancelOrderModalShow = false;
          this.cancelOrderCommitting = false;
          // 延迟获取当前委托的原因是因为后台处理会有延迟
          this.onCancelOrderModalHide();
          let timer = setTimeout(() => {
            this.$emit('getUserAccountData');
            this.getCurrentEntrust();
            // this.getHistoryEntrust();
            clearTimeout(timer);
          }, 600);
        })
        .catch(() => {
          this.cancelOrderCommitting = false;
        });
    },
    // 提交撤销所有订单数据
    _requestCancelAllOrder(symbol) {
      tradeApi
        .cancelAllOrder(symbol)
        .then(() => {
          this.successNotify(this.$t('success.allOrderCancel'));

          this.cancelAllModalShow = false;
          this.cancelAllCommitting = false;
          this.onCancelOrderModalHide();
          let timer = setTimeout(() => {
            this.getCurrentEntrust();
            this.getHistoryEntrust();
            clearTimeout(timer);
          }, 600);
        })
        .catch(() => {
          this.cancelAllCommitting = false;
        });
    },
    // 显示批量撤销modal
    _showCancelAllModal() {
      if (this.currentEntrust.data.length > 0) {
        this.cancelAllModalShow = true;
      }
    },
    // 显示撤销单个订单modal
    _cancelOrderModalShow(row) {
      this.cancelOrderId = row.id;
      this.cancelOrderPair = row.symbol;
      this.cancelOrderModalShow = true;
      this.currentEntrust.state = CONFIRMINGCANCEL;
    },
    subscribeOrderList() {
      this.$socket.subscribe('orderList', value => {
        if (this.selectedTab === 0) {
          this.currentEntrust.hasMessage = true;
          this.historyEntrust.hasMessage = false;
          this.getCurrentEntrust();
        } else if (this.selectedTab === 1) {
          this.currentEntrust.hasMessage = false;
          this.historyEntrust.hasMessage = true;
          this.getHistoryEntrust();
        }
        this.$emit('getUserAccountData');
      });
    },
    unsubscribeOrderList() {
      this.$socket.unsubscribe('orderList');
    },
    subscribeMatchedOrder() {
      this.$socket.subscribe('matchedOrder', value => {
        if (!this.isNaN(this.Getter_User_Info.id) && Number(this.Getter_User_Info.id) < 999999) {
          this.matchOrderModalShow = true;
          this.matchCount++;
          this.playSound();
        }
      });
    },
    unsubscribeMatchedOrder() {
      this.$socket.unsubscribe('matchedOrder');
    },
    // convertDecimal(value, decimal) {
    //   if (!value) {
    //     return value;
    //   }
    //   return tool.decimalRetain(value, decimal);
    // },
    playSound() {
      new Howl({
        src: ['elevator-ding.mp3'],
        autoplay: true,
        loop: false,
        volume: 0.5
      });
    }
  },
  computed: {
    ...mapGetters([
      getterTypes.Getter_Token,
      getterTypes.Getter_Current_Market,
      getterTypes.Getter_Socket_State,
      getterTypes.Getter_User_Info,
      getterTypes.Getter_Market_List,
    ]),
    // 订单来源 字典
    clientType() {
      return tool.arrayConvertToObject(selectOption.clientType);
    },
    // 交易类型 字典
    transType() {
      return tool.arrayConvertToObject(selectOption.transType);
    }
  },
  watch: {
    Getter_Current_Market() {
      if (this.Getter_Token) {
        this.currentEntrust.state = READY;
        this.historyEntrust.state = READY;
        this.getCurrentEntrust();
        this.getHistoryEntrust();
      }
    },
    selectedTab(val) {
      if (this.selectedTab === 0) {
        this.getCurrentEntrust();
      } else if (this.selectedTab === 1) {
        this.getHistoryEntrust();
      }
    },
    Getter_Socket_State(value) {
      if (value) {
        this.subscribeOrderList();
      }
    }
  },
  components: {
    // BootstrapModal,
    // CommonTable,
    OpenOrderTable,
    HistoryOrderTable,
    ConfirmModal,
    MessageModal
  },
  async created() {
    if (this.Getter_Token) {
      this.historyEntrust.loading = true;
      this.currentEntrust.loading = true;
      this.getCurrentEntrust();
      await this.getMarketPair_action();
      this.getHistoryEntrust();
      if (this.Getter_Socket_State) {
        this.subscribeOrderList();
        this.subscribeMatchedOrder();
      }
      if (this.isEmpty(this.Getter_Market_List)){
        this.GET_MARKETLIST_ACTION();
      }
      // if (this.Getter_Market_List.length)
    }
  },
  beforeDestroy() {
    this.unsubscribeOrderList();
    this.unsubscribeMatchedOrder();
  }
};
